import { ApiError } from "./errors";
import type { ApiClient } from "./client";
import type { PublicAccount } from "./types";

export async function fetchCurrentAccount(
  client: ApiClient,
  options?: { signal?: AbortSignal },
): Promise<PublicAccount | null> {
  try {
    return await client.request<PublicAccount>("/api/v1/auth/me", {
      handleAuthExpiry: false,
      signal: options?.signal,
    });
  } catch (error) {
    if (error instanceof ApiError && error.code === "AUTH_REQUIRED") {
      return null;
    }
    throw error;
  }
}

export async function login(
  client: ApiClient,
  username: string,
  password: string,
): Promise<PublicAccount> {
  return client.request<PublicAccount>("/api/v1/auth/login", {
    method: "POST",
    body: { username, password },
    handleAuthExpiry: false,
  });
}

export async function startDemo(client: ApiClient): Promise<PublicAccount> {
  return client.request<PublicAccount>("/api/v1/auth/demo-session", {
    method: "POST",
    body: {},
    handleAuthExpiry: false,
  });
}

export async function logout(client: ApiClient): Promise<void> {
  try {
    await client.request<void>("/api/v1/auth/logout", {
      method: "POST",
      handleAuthExpiry: false,
    });
  } catch (error) {
    // Logout is idempotent: expired/missing session is still a successful local logout.
    if (error instanceof ApiError && error.code === "AUTH_REQUIRED") {
      return;
    }
    throw error;
  }
}

export async function changePassword(
  client: ApiClient,
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  await client.request<void>("/api/v1/auth/change-password", {
    method: "POST",
    body: { currentPassword, newPassword },
  });
}
